import { IconSettings } from '@tabler/icons-react';
import { NSButton, NSCard } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import React, { Fragment } from 'react';
import {
    DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, UncontrolledDropdownProps,
} from 'reactstrap';

interface IMenuItem {
    key: string,
    label: string,
    visible: boolean,
    rightComponent: React.ReactNode,
    onClick?: () => void,
    children?: React.ReactNode,
}

export interface INSSettingsMenuProps extends UncontrolledDropdownProps{
    isMenuOpen: boolean;
    toggleMenu: () => void;
    menuItems:IMenuItem[];
    childMenuType?: string | null;

}

const NSSettingsMenu: React.FC<INSSettingsMenuProps> = ({
    isMenuOpen, toggleMenu, menuItems, childMenuType,
}) => ((
    <UncontrolledDropdown isOpen={isMenuOpen} toggle={toggleMenu}>
        <DropdownToggle tag="div">
            <NSButton icon={IconSettings} className="mr-1 NSButton--secondary-lighten cursor--pointer" />
        </DropdownToggle>
        <DropdownMenu
            container="body"
            className="p-0 m-0 bg-transparent z-index-100 ProFormaSideNavSettingsMenu__dropdown-menu"
        >

            <NSCard className="NSCard--level-5 shadow-none py-2">
                {menuItems.filter(item => item.visible).map(item => (
                    <Fragment key={item.key}>
                        <RenderIf isTrue={!childMenuType}>
                            <DropdownItem
                                toggle={false}
                                className="d-flex justify-content-between align-items-center text-wrap"
                                onClick={item.onClick}
                            >
                                <span>{item.label}</span>
                                {item.rightComponent}
                            </DropdownItem>
                        </RenderIf>

                        <RenderIf isTrue={childMenuType === item.key && item.children}>
                            {item.children}
                        </RenderIf>
                    </Fragment>
                ))}
            </NSCard>
        </DropdownMenu>
    </UncontrolledDropdown>
));

export default NSSettingsMenu;
